import { AuthenticationClient } from '../features/authentication/slice/authenticationSlice'
import { useAppDispatch } from '../app/typedReduxHooks'
import ClientSSOContext, { SSO_PROVIDER_PLATFORM } from '../features/sso/types/ClientSSOContext'

export const useLogout = () => {
  const dispatch = useAppDispatch()
  return async () => {
    const clientId = localStorage.getItem('client_id')
    const clientSSOContextString = localStorage.getItem('clientSSOContext')
    const clientSSOContext: ClientSSOContext | null = clientSSOContextString
      ? JSON.parse(clientSSOContextString)
      : null

    const isExternalCognitoIdP =
      clientSSOContext?.providerPlatform === SSO_PROVIDER_PLATFORM.COGNITO

    await dispatch(AuthenticationClient.Logout())

    if (clientId) {
      if (isExternalCognitoIdP) {
        window.location.href = process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI || '/'
      } else {
        window.location.href = `${process.env.REACT_APP_COGNITO_AUTH_URI}/logout?client_id=${clientId}&logout_uri=${process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI}`
      }
    }
  }
}
